import { collection, doc, getDoc, getDocs, setDoc, deleteDoc, getFirestore } from 'firebase/firestore';
import app from '../config/firebase';

const db = getFirestore(app);

export const COLECCION_PETSHOP = 'petshop';
export const COLECCION_PETSHOP_PUBLICO = 'petshopPublico';

// Descuento en porcentaje (1-99). Sin descuento devuelve 0.
export const descuentoDe = (p) => {
  const d = Number(p && p.descuento) || 0;
  return d > 0 && d < 100 ? d : 0;
};

// Precio de venta ya con el descuento aplicado (redondeado a pesos enteros).
export const precioFinal = (p) => {
  const precio = Number(p && p.precioVenta) || 0;
  const d = descuentoDe(p);
  return d ? Math.round(precio * (1 - d / 100)) : precio;
};

// Copia pública de un producto: solo lo que se muestra en la web.
// Nunca incluye precio de compra ni cantidades exactas de stock.
const aDocumentoPublico = (p) => ({
  titulo: p.titulo || '',
  categoria: (p.categoria || '').trim(),
  descripcion: p.descripcion || '',
  precioVenta: Number(p.precioVenta) || 0,
  descuento: descuentoDe(p),
  imagenURL: p.imagenURL || '',
  disponible: (Number(p.cantidad) || 0) > 0
});

// Mensaje del último error de sincronización (para mostrarlo al personal en el admin)
let ultimoError = '';
export const obtenerUltimoErrorSincronizacion = () => ultimoError;
const mensajeDe = (error) => (error && (error.code || error.message)) || String(error);

// Un producto sin el campo `visible` (creado antes de existir la opción) se considera visible.
const esVisible = (p) => p.visible !== false;

// Refleja el estado actual de un producto del petshop en la colección pública.
// Si el producto ya no existe o está oculto, elimina su copia. No lanza: solo registra el error.
export const sincronizarProductoPublico = async (id) => {
  try {
    const snap = await getDoc(doc(db, COLECCION_PETSHOP, id));
    const refPublico = doc(db, COLECCION_PETSHOP_PUBLICO, id);
    if (snap.exists() && esVisible(snap.data())) {
      await setDoc(refPublico, aDocumentoPublico(snap.data()));
    } else {
      await deleteDoc(refPublico);
    }
    return true;
  } catch (error) {
    console.error('No se pudo sincronizar el producto público del petshop:', error);
    ultimoError = mensajeDe(error);
    return false;
  }
};

export const eliminarProductoPublico = async (id) => {
  try {
    await deleteDoc(doc(db, COLECCION_PETSHOP_PUBLICO, id));
    return true;
  } catch (error) {
    console.error('No se pudo eliminar el producto público del petshop:', error);
    return false;
  }
};

// Deja la vitrina pública idéntica a lo que hay en el petshop: escribe los visibles,
// quita los ocultos y borra las copias huérfanas (productos que ya no existen).
export const sincronizarProductosPublicos = async (productos) => {
  try {
    const idsActuales = new Set(productos.map((p) => p.id));
    const publicos = await getDocs(collection(db, COLECCION_PETSHOP_PUBLICO));
    await Promise.all(
      publicos.docs
        .filter((d) => !idsActuales.has(d.id))
        .map((d) => deleteDoc(doc(db, COLECCION_PETSHOP_PUBLICO, d.id)))
    );
    await Promise.all(
      productos.map((p) =>
        esVisible(p)
          ? setDoc(doc(db, COLECCION_PETSHOP_PUBLICO, p.id), aDocumentoPublico(p))
          : deleteDoc(doc(db, COLECCION_PETSHOP_PUBLICO, p.id))
      )
    );
    return true;
  } catch (error) {
    console.error('No se pudo sincronizar la vitrina pública del petshop:', error);
    ultimoError = mensajeDe(error);
    return false;
  }
};
